// Collèges d'associés SCIC — art. 23 des statuts signés AGE 10 août 2026
import { Star, Briefcase, Bank, GlobeHemisphereWest, Rocket, UsersThree, Handshake } from '@phosphor-icons/react';

export const COLLEGES = [
  { value: 'A', label: 'Porteurs et vision stratégique',            ponderation: 30, color: '#2D5A4C', Icon: Star },
  { value: 'B', label: 'Salariés, entrepreneurs salariés & GE',     ponderation: 10, color: '#62A8D4', Icon: Briefcase },
  { value: 'C', label: 'Partenaires, collectivités & organismes',   ponderation: 10, color: '#8DB0A1', Icon: Bank },
  { value: 'D', label: 'Fédérations & monde économique',            ponderation: 10, color: '#E8A365', Icon: GlobeHemisphereWest },
  { value: 'E', label: 'Développeurs',                              ponderation: 20, color: '#D47A62', Icon: Rocket },
  { value: 'F', label: 'Utilisateurs, bénéficiaires & habitants',   ponderation: 10, color: '#7A8FAA', Icon: UsersThree },
  { value: 'G', label: 'Coopérateurs contributeurs',                ponderation: 10, color: '#5E6D66', Icon: Handshake },
];

export const findCollege = (value) => COLLEGES.find(c => c.value === value);
